import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
const BASE = `${API_URL}/api/accounting/ap-match-review`;

function authConfig() {
  const token = localStorage.getItem('token');
  return { headers: { Authorization: `Bearer ${token}` } };
}

export async function runMatcher() {
  const res = await axios.post(`${BASE}/run`, {}, authConfig());
  return res.data;
}

export async function getRunStatus() {
  const res = await axios.get(`${BASE}/run-status`, authConfig());
  return res.data;
}

export async function getStats() {
  const res = await axios.get(`${BASE}/stats`, authConfig());
  return res.data;
}

export async function getPending({ bucket, page = 1, limit = 100 } = {}) {
  const qs = new URLSearchParams({ page, limit, ...(bucket ? { bucket } : {}) });
  const res = await axios.get(`${BASE}/pending?${qs}`, authConfig());
  return res.data;
}

export async function approveProposal(proposalId, notes) {
  const res = await axios.post(`${BASE}/approve`, { proposal_id: proposalId, notes }, authConfig());
  return res.data;
}

export async function rejectProposal(proposalId, reason) {
  const res = await axios.post(`${BASE}/reject`, { proposal_id: proposalId, reason }, authConfig());
  return res.data;
}

export async function bulkApprove(proposalIds, notes) {
  const res = await axios.post(`${BASE}/bulk-approve`, { proposal_ids: proposalIds, notes }, authConfig());
  return res.data;
}
